import {AdapterProps, FieldAdapter} from '../field-factory';
import {TimeInput as MantineTimeInput, TimeInputProps} from '@mantine/dates';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $TimeInputAdapterProps = AdapterProps<
  Omit<TimeInputProps, 'rightSection'>
>;

export const $TimeInputAdapter: FC<FieldAdapter<$TimeInputAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: TimeInputProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  const {readOnly} = useContext(ReadOnlyContext);

  return (
    <MantineTimeInput
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};